import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=840bac78&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!C:/Users/lbakker/Projects/Hearingcoach/cartfinity.hearingcoach.shop/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormRadio, BFormGroup} from 'bootstrap-vue'
    installComponents(component, {BFormRadio, BFormGroup})
    

export default component.exports